"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollHandler() {
  const pathname = usePathname();

  useEffect(() => {
    // Force scroll to top on page load for non-home pages
    const handleLoad = () => {
      if (pathname !== '/' && !window.location.hash) {
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, 0);
      }
    };

    // Handle navigation events
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    // Handle popstate (back/forward navigation)
    const handlePopState = () => {
      if (!window.location.hash) {
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, 0);
      }
    };

    // Initial setup
    if (typeof window !== 'undefined') {
      window.addEventListener('load', handleLoad);
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);

      // Handle hash links from other pages (skip OAuth callback fragments)
      const hash = window.location.hash;
      const isSimpleHash = hash && /^#[a-zA-Z][\w-]*$/.test(hash);
      if (isSimpleHash && pathname !== '/') {
        setTimeout(() => {
          try {
            const element = document.querySelector(hash);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } catch {
            // Invalid selector (e.g. OAuth token fragments), ignore
          }
        }, 100);
      } else if (pathname !== '/') {
        // Force immediate scroll to top for non-home pages
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }

      // Override Next.js router scroll behavior
      if (window.history && window.history.scrollRestoration) {
        window.history.scrollRestoration = 'manual';
      }
    }

    // Cleanup
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('load', handleLoad);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handlePopState);
      }
    };
  }, [pathname]);

  return null; // Este componente no renderiza nada
}